
angular.module('bmsApp.employeeTeam', [])

	.config([
		'$stateProvider',
		'$urlRouterProvider',
		'BMSPermission', function config(
			$stateProvider,
			$urlRouterProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.employee.index.teams', {
					url: '/teams',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employeeTeam/templates/EmployeeTeamIndex.html",
							controller: 'EmployeeTeamIndexCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Manage Teams'}
				})

				;

		}]);
	